import React from 'react'
import { Col, Container, Form, InputGroup, Row } from 'react-bootstrap'
import { Plan, PricePeriod } from '../../../models/Plan'
import { SelectDropdown, SelectOption } from '../../../components/SelectDropdown/SelectDropdown'

interface PeriodUpgradeBodyProps {
  period: PricePeriod
  onPeriodChange: (period: PricePeriod) => void
}

export const PeriodUpgradeBody: React.FC<PeriodUpgradeBodyProps> = ({ period, onPeriodChange }) => {
  const options = [
    { id: 'month', label: 'Monthly' },
    { id: 'year', label: 'Annual' },
  ]
  const onOptionSelected = (option: SelectOption) => {
    onPeriodChange(option.id as PricePeriod)
  }
  return (
    <Container className='p-0'>
      <Row>
        <Col>
          <SelectDropdown
            initialSelectedOption={options.find((p) => p.id === period)}
            options={options}
            className='px-2 py-1 paragraph-small'
            onOptionSelected={onOptionSelected}
          />
        </Col>
      </Row>
    </Container>
  )
}
